import { useCallback, useEffect, useMemo, useState } from "react";
import { isMobile } from "react-device-detect";
import { SetBeforeInstallEvent } from "../../../store/actions/general/GeneralActions";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "../../../store/Store";

export const useInstallPWA = () => {
  const dispatch = useDispatch();
  const [isInstalled, setIsInstalled] = useState<boolean>(true);
  const generalState = useSelector((state: RootStore) => state.general);

  const isInStandaloneMode = () =>
    window.matchMedia("(display-mode: standalone)").matches;

  useEffect(() => {
    if (!isInStandaloneMode()) {
      setIsInstalled(false);
    }
  }, []);

  useEffect(() => {
    if (isMobile && !isInstalled) {
      window.addEventListener("beforeinstallprompt", (event) => {
        console.log("beforeinstallprompt called");
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        event.preventDefault();
        // Stash the event so it can be triggered later.
        dispatch(SetBeforeInstallEvent(event));
      });
    }
  }, [isInstalled]);

  const installPWA = useCallback(() => {
    if (generalState?.beforeInstallEvent) {
      // @ts-ignore
      generalState?.beforeInstallEvent.prompt();
    }
  }, [generalState?.beforeInstallEvent]);

  return useMemo(() => {
    return {
      isInstalled,
      installPWA,
      deferredPrompt: generalState?.beforeInstallEvent,
    };
  }, [isInstalled, installPWA, generalState?.beforeInstallEvent]);
};
